module.exports = "/_next/static/images/router-0865fd6d266fea8a86e40f8bdd9a06f1.png";